import * as PIXI from "pixi.js";
import { TopSwitcherOptions } from "../../../types/Interface";


export default class TopButtonRenderer extends PIXI.Container {
  private bgBottom = this.addChild(new PIXI.Graphics());
  private bgMid = this.addChild(new PIXI.Graphics());
  private buttonLabel;

  constructor(private butLabel: string, private options?: TopSwitcherOptions) {
    super();
    this.draw();
  }

  drawBottomBg = (color: number = 0xFFFFFF) => this.drawBg(this.bgBottom, color);
  drawMidBg = () => {
    const color = this.options?.buttonColor || 0x0195b8;
    this.drawBg(this.bgMid, color);
    this.setButtonLabelColor(0xFFFFFF);
  };
  clearMidBg = () => {
    this.bgMid.clear();
    this.setButtonLabelColor(0x333333);
  }
  private draw() {
    this.addText();
    this.drawBottomBg();
  }
  private drawBg(bg: PIXI.Graphics, color: number) {
    const w = this.buttonLabel.width;
    const h = this.options?.buttonHeight || 40;
    bg
      .clear()
      .moveTo(-w / 2 - h / 2, -20)
      .roundRect(-w / 2 - 20, -h / 2, w + 40, h, 6)
      .fill(color)
  }
  private addText() {
    const fontSize = this.options?.fontSize || 16;
    this.buttonLabel = this.addChild(new PIXI.Text())
    this.buttonLabel.text = this.butLabel;
    this.buttonLabel.anchor.set(.5);
    this.buttonLabel.style = {
      fill: 0x333333,
      fontSize
    }
  }
  private setButtonLabelColor = (color: number) => this.buttonLabel.style.fill = color;
}